module.exports = __webpack_public_path__ + "assets/img/sam_simon-58311eea.jpg";